import React from "react";

const SHYFT_LOGO = "/shyft-coalition.jpg";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 py-14 md:py-16"
    >
      <div className="mx-auto max-w-3xl px-6 md:px-10 text-center">
        <div className="flex flex-col items-center gap-4">
          <a
            href="https://shyftcoalition.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block shrink-0"
            style={{ width: 56, height: 56 }}
            data-testid="footer-shyft-logo-link"
          >
            <img
              src={SHYFT_LOGO}
              alt="SHYFT Coalition"
              width="56"
              height="56"
              className="rounded-xl block"
              style={{
                width: 56,
                height: 56,
                objectFit: "cover",
                boxShadow:
                  "0 0 0 1px rgba(255,255,255,0.08), 0 6px 24px rgba(0,0,0,0.5)",
              }}
              data-testid="footer-shyft-logo"
            />
          </a>

          <p
            className="text-xs md:text-sm text-white/70 italic"
            data-testid="footer-sponsor"
          >
            This webpage is sponsored by the{" "}
            <a
              href="https://shyftasap.com"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors italic font-semibold"
              style={{ color: "#D4A24C" }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#F2C977")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#D4A24C")}
              data-testid="footer-link-shyft"
            >
              SHYFT Coalition<sup style={{ color: "#D4A24C", fontSize: "0.5em", verticalAlign: "0.55em", marginLeft: "0.06em", fontWeight: 600 }}>TM</sup>
            </a>
          </p>
        </div>

        <div
          className="mt-8 pt-6 border-t border-white/10 text-[11px] text-white/45 tracking-wide"
          data-testid="footer-copyright"
        >
          <span className="block">© 2026 SHYFT Coalition<sup style={{ fontSize: "0.55em", verticalAlign: "0.55em", marginLeft: "0.06em", fontWeight: 500 }}>TM</sup></span>
          <span className="block">All Rights Reserved.</span>
        </div>
      </div>
    </footer>
  );
};
